import { render, staticRenderFns } from "./TvaSideNav.vue?vue&type=template&id=021eb079&scoped=true&"
import script from "./TvaSideNav.vue?vue&type=script&lang=js&"
export * from "./TvaSideNav.vue?vue&type=script&lang=js&"
import style0 from "./TvaSideNav.vue?vue&type=style&index=0&id=021eb079&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021eb079",
  null
  
)

export default component.exports